
(function($) {
	
	"use strict";

	

	/*
		search
	*/
	if (!customElements.get('year-search')) {
		customElements.define('year-search', class YearSearch extends HTMLElement {
			constructor(){
				super()
				this.urlPath = ''
				this.year = document.querySelector('.select-year-parts')
				this.year.addEventListener('change', this.getMake.bind(this))
				this.makeDone = ''

				this.make = document.querySelector('.select-make-parts')
				this.make.addEventListener('change', this.getModel.bind(this))
				this.ModelDone = ''

				
				this.model = document.querySelector('.select-model-parts')
				this.model.addEventListener('change', this.getSubModel.bind(this))
				this.SubModelDone = ''

				this.submodel = document.querySelector('.select-sub-model-parts')
				this.submodel.addEventListener('change', this.getEng.bind(this))
				this.engineDone = ''
				
				this.engine = document.querySelector('.select-engine-parts')
				this.engine.addEventListener('change', this.finalEng.bind(this))
				this.engineFinal = ''
				this.formId = document.getElementById('the-forid')
				this.initYearSearch()

			}
			getMake(evt){
				let selectVal = this.year.options[this.year.selectedIndex].value
				if( selectVal == 'select'){
					this.make.disabled = true
					this.model.disabled = true
					this.submodel.disabled = true
					this.engine.disabled = true
				}else{

					this.model.disabled = true
					this.submodel.disabled = true
					this.engine.disabled = true
					this.makeDone = selectVal
					this.urlPath = `/collections/all?filter.p.m.year_n.year_k=${selectVal}`
					this.formId.setAttribute("href", this.urlPath)
					axios.get(`/collections/all?filter.p.m.year_n.year_k=${selectVal}&view=ajax`)
					.then(
						response => {
							let parser = new DOMParser();
							const dataParce = parser.parseFromString(response.data, 'text/html')
							const dataParceTarget = dataParce.querySelector('.select-make-parts-result')

							let newMakeA = []
							for (var i=0, n=dataParceTarget.options.length; i<n; i++) {
								if (dataParceTarget.options[i].value) newMakeA.push(dataParceTarget.options[i].value);
							}
							let uniqueArray = newMakeA.filter(function(item, pos, self) {
								return self.indexOf(item) == pos;
							})
							var newMake = '<option value="' + 'select' + '">' + 'select' + '</option>'
							uniqueArray.forEach(
								option => {
									newMake += '<option value="' + option + '">' + option + '</option>';
								}
							)
							this.make.innerHTML = newMake
							this.make.disabled = false
						}
					)
					.catch(function (error) {
						console.log(error)
					})
					.finally(() => {
						// you finaly code here
					})


				}
			}

			getModel(evt){
				
				let selectMake = this.make.options[this.make.selectedIndex].value
				if( selectMake == 'select'){
					this.model.disabled = true
					this.submodel.disabled = true
					this.engine.disabled = true
				}else{
					this.submodel.disabled = true
					this.engine.disabled = true
					this.ModelDone = selectMake
					this.urlPath = `/collections/all?filter.p.m.make_n.make_k=${selectMake}&filter.p.m.year_n.year_k=${this.makeDone}`
					this.formId.setAttribute("href", this.urlPath)
					axios.get(`/collections/all?filter.p.m.make_n.make_k=${selectMake}&filter.p.m.year_n.year_k=${this.makeDone}&view=ajax`)
					.then(
						response => {
							let parser = new DOMParser();
							const data = parser.parseFromString(response.data, 'text/html')
							const dataParceTarget = data.querySelector('.select-model-parts-result')
							
							let newModel = []
							for (var i=0, n=dataParceTarget.options.length; i<n; i++) {
								if (dataParceTarget.options[i].value) newModel.push(dataParceTarget.options[i].value);
							}
							let uniqueArray = newModel.filter(function(item, pos, self) {
								return self.indexOf(item) == pos;
							})
							var newModelRen = '<option value="' + 'select' + '">' + 'select' + '</option>'
							uniqueArray.forEach(
								option => {
									newModelRen += '<option value="' + option + '">' + option + '</option>';
								}
							)

							this.model.innerHTML = newModelRen
							this.model.disabled = false

						}
					)
					.catch(function (error) {
						console.log(error)
					})
					.finally(() => {
						// you finaly code here
					})
				}
				
			}

			getSubModel(evt){
				let selectModel = this.model.options[this.model.selectedIndex].value

				if( selectModel == 'select'){
					this.submodel.disabled = true
					this.engine.disabled = true
				}else{
					this.SubModelDone = selectModel
					this.urlPath = `/collections/all?filter.p.m.make_n.make_k=${this.ModelDone}&filter.p.m.model_n.model_k=${selectModel}&filter.p.m.year_n.year_k=${this.makeDone}`
					this.formId.setAttribute("href", this.urlPath)
					axios.get(`/collections/all?filter.p.m.make_n.make_k=${this.ModelDone}&filter.p.m.model_n.model_k=${selectModel}&filter.p.m.year_n.year_k=${this.makeDone}&view=ajax`)
					.then(
						response => {
							let parser = new DOMParser();
							const data = parser.parseFromString(response.data, 'text/html')

							// class name
							const dataParceTarget = data.querySelector('.select-sub-model-parts-result')
							
							let subNewModel = []
							for (var i=0, n=dataParceTarget.options.length; i<n; i++) {
								if (dataParceTarget.options[i].value) subNewModel.push(dataParceTarget.options[i].value);
							}
							let uniqueArray = subNewModel.filter(function(item, pos, self) {
								return self.indexOf(item) == pos;
							})
							var subNewModelRe = '<option value="' + 'select' + '">' + 'select' + '</option>'
							uniqueArray.forEach(
								option => {
									subNewModelRe += '<option value="' + option + '">' + option + '</option>';
								}
							)
							this.submodel.innerHTML = subNewModelRe
							this.submodel.disabled = false

							// class name
							const dataEng = data.querySelector('.select-engine-parts-result')

							let newEng = []
							for (var i=0, n=dataEng.options.length; i<n; i++) {
								if (dataEng.options[i].value) newEng.push(dataEng.options[i].value);
							}
							let uniqueEng = newEng.filter(function(item, pos, self) {
								return self.indexOf(item) == pos;
							})
							var uniqueEngSelect = '<option value="' + 'select' + '">' + 'select' + '</option>'
							uniqueEng.forEach(
								option => {
									uniqueEngSelect += '<option value="' + option + '">' + option + '</option>';
								}
							)
							this.engine.innerHTML = uniqueEngSelect
							this.engine.disabled = false

						}
					)
					.catch(function (error) {
						console.log(error)
					})
					.finally(() => {
						// you finaly code here
					})
				}
			}

			getEng(evt){
				
				let selectEng = this.submodel.options[this.submodel.selectedIndex].value

				if( selectEng != 'select'){
					this.engineDone = selectEng
					this.urlPath = `/collections/all?filter.p.m.make_n.make_k=${this.ModelDone}&filter.p.m.model_n.model_k=${this.SubModelDone}&filter.p.m.sub_model_n.sub_model_k=${selectEng}&filter.p.m.year_n.year_k=${this.makeDone}`
					this.formId.setAttribute("href", this.urlPath)
					axios.get(`/collections/all?filter.p.m.make_n.make_k=${this.ModelDone}&filter.p.m.model_n.model_k=${this.SubModelDone}&filter.p.m.sub_model_n.sub_model_k=${selectEng}&filter.p.m.year_n.year_k=${this.makeDone}&view=ajax`)
					.then(
						response => {
							let parser = new DOMParser();
							const data = parser.parseFromString(response.data, 'text/html')
							const dataEng = data.querySelector('.select-engine-parts-result')


							let newEng= []
							for (var i=0, n=dataEng.options.length; i<n; i++) {
								if (dataEng.options[i].value) newEng.push(dataEng.options[i].value);
							}
							let uniqueEng = newEng.filter(function(item, pos, self) {
								return self.indexOf(item) == pos;
							})
							var newEngS = '<option value="' + 'select' + '">' + 'select' + '</option>'
							uniqueEng.forEach(
								option => {
									newEngS += '<option value="' + option + '">' + option + '</option>';
								}
							)
							this.engine.innerHTML = newEngS
						}
					)
					.catch(function (error) {
						console.log(error)
					})
					.finally(() => {
						// you finaly code here
					})
				}

				if( selectEng == 'select'){
					this.getSubModel()
				}
			}

			finalEng(evt){
				evt.preventDefault()
				let selectVal = this.engine.options[this.engine.selectedIndex].value
				if( selectVal != 'select'){
				}
			}

			initYearSearch(){
				axios.get(`/collections/all?view=ajax`)
				.then(
					response => {
						let parser = new DOMParser();
						const dataParce = parser.parseFromString(response.data, 'text/html')
						const dataParceTarget = dataParce.querySelector('.select-year-parts-result')
						let newYear = []

						for (var i=0, n=dataParceTarget.options.length; i<n; i++) {
							if (dataParceTarget.options[i].value) newYear.push(dataParceTarget.options[i].value);
						}
						
						let uniqueArray = newYear.filter(function(item, pos, self) {
							return self.indexOf(item) == pos;
						})

						var newYearOp = '<option value="' + 'select' + '">' + 'select' + '</option>'
						uniqueArray.forEach(
							option => {
								newYearOp += '<option value="' + option + '">' + option + '</option>';
							}
						)
						this.year.innerHTML = newYearOp
						
					}
				)
				.catch(function (error) {
					console.log(error)
				})
				.finally(() => {
					// you finaly code here
				})
			}
		})
	}
	/*
		search
	*/
		let searchIcon = document.querySelector('.search-icon-for-mobile')
	searchIcon.addEventListener('click', e => {
		document.body.classList.add("slide-search-open")
	})

	let searchIconC = document.querySelector('.brator-search-area-for-mobile-close')
	searchIconC.addEventListener('click', e => {
		document.body.classList.remove("slide-search-open")
	})

	/*
		loadd popup newletter close
	*/
	
	document.addEventListener( 'DOMContentLoaded', function () {



		let popUpCloseO = document.querySelector('.popup-subdone-click')
		let popUpClose = document.querySelector('.brator-newsletter-pops-close')
		let popupFull = document.querySelector('.brator-news-letter-main-popup')


		let closePopupanyWay = localStorage.getItem('popup') ? localStorage.getItem('popup') : '' 

		if(closePopupanyWay == 'popup-dec' ){
			popupFull.style.display = 'none';
		} else{
			setTimeout(popupOpen, 5000)
		}

		function popupOpen(){
			popupFull.style.display = 'flex';
		}

		popUpClose.addEventListener('click', function(){
			localStorage.setItem('popup', 'popup-dec')
			popupFull.style.display = 'none';
		})
		popUpCloseO.addEventListener('click', function(){
			localStorage.setItem('popup', 'popup-dec')
			popupFull.style.display = 'none';
		})

		let urlPath = `${window.origin}/collections/`

		var tabProductAjax = document.querySelectorAll('.ajax-product-link button')
		if( tabProductAjax != null ){
			const tabNew = document.querySelector('#axi-product-tab')
			tabProductAjax.forEach(
				item => {
					let handler = item.dataset.handel
					item.addEventListener('click', e => {
						let updateUrlpath = urlPath + handler + '?view=coluct'

						tabNew.classList.add("loading-overlay")
						axios({
							method: "get",
							url: updateUrlpath
						})
						
						.then(
							response => {
								
								let parser = new DOMParser();
								const dataParce = parser.parseFromString(response.data, 'text/html')
								const dataParceTarget = dataParce.querySelector('#get_the_slider')
								

								tabNew.innerHTML = dataParceTarget.innerHTML

								let elms = document.getElementsByClassName( 'splide' );
								if(elms.length > 0 ){
									for ( let i = 0, len = elms.length; i < len; i++ ) {
										new Splide( elms[ i ] ).mount();
									}
								}
							}
						)
						.catch(function (error) {
							console.log(error)
						})
						.finally(() => {
							tabNew.classList.remove("loading-overlay")
							console.log('finally')
						})
					})
				}
			)
		}


		/*
			gsap start
		*/
	
		$('.brator-app-area').each(function(){

			var gsapTimeline = new TimelineMax();
			var controller = new ScrollMagic.Controller(
				{
					loglevel: 0
				}
			);
	

			var bgImg = $(this).find(".brator-app-content-area");
			 var tween2 = TweenMax.fromTo(
				bgImg,
				1,
				{
					css:{
						backgroundPosition:'45% -25px'
					},
					ease: Linear.easeNone
				},
				{
					css:{
						backgroundPosition:'55% -25px'
					},
					ease: Linear.easeNone
				}
			);
			gsapTimeline
					.add(tween2);
			var sectionBg = new ScrollMagic.Scene({
				tweenChanges: true,
				triggerElement: this,
				offset: 0,
				duration: "60%",
				triggerHook: 'onCenter', /// onEnter // onLeave
				loglevel: 2	
			})
			.addTo(controller)
			.setTween(
				gsapTimeline
			)
		});

		/*
			gsap end
		*/


		/*
			headre
		*/

		function headerStyle() {
			if($('.scroll-top').length){
				var windowpos = $(window).scrollTop();
				var scrollLink = $('.scroll-top');
				if (windowpos >= 270) {
					scrollLink.addClass('open');
				} else {
					scrollLink.removeClass('open');
				}
			}
		}


		/*
			scroll
		*/

		if($('.scroll-to-target').length){
			$(".scroll-to-target").on('click', function() {
				var target = $(this).attr('data-target');
			   // animate
			   $('html, body').animate({
				   scrollTop: $(target).offset().top
				 }, 1000);
		
			});
		}

		function scrollMenuStyle() {
			if($('.scroll-menu').length){
				var windowpos = $(window).scrollTop();
				var scrollLink = $('.scroll-menu');
				if (windowpos >= 270) {
					scrollLink.addClass('open');
				} else {
					scrollLink.removeClass('open');
				}
			}
		}


		/*
			scroll end
		*/

		$(window).on('scroll', function() {
			headerStyle();
			scrollMenuStyle();
		});
      
        $(document).ready(function() {
         handlePreloader();
        });

		// $(window).on('load', function() {
		// 	handlePreloader() && alert("window is loaded");
		// });
		/*
			splide start
		*/
	
		if($('.newsletter-form__message').length){
			setTimeout(function(){ 
				$('.newsletter-form__message').addClass('newsletter-form__message--success-hide');
			}, 3000);
		};

		
		let elms = document.getElementsByClassName( 'splide' );
		if(elms.length > 0 ){
			for ( let i = 0, len = elms.length; i < len; i++ ) {
				new Splide( elms[ i ] ).mount();
			}
		}
		
		document.addEventListener("shopify:section:load", e => {
			let elms = document.getElementsByClassName( 'splide' );
			if(elms.length > 0 ){
			  for ( let i = 0, len = elms.length; i < len; i++ ) {
				new Splide( elms[ i ] ).mount();
			  }
			}
		});

		  

		var productSliderPrice = document.getElementById('brator-rang-item-slider-nou');
		if( productSliderPrice != null ){
			noUiSlider.create(productSliderPrice, {
				start: [20, 80],
				connect: true,
				range: {
					'min': 0,
					'max': 100
				}
			});
		}
	let reviewSyncAuthore = document.getElementsByClassName( 'brator-client-review-author' );
	let reviewSyncReview = document.getElementsByClassName( 'brator-client-review' );

	if(reviewSyncAuthore.length > 0 ){
		// reviewSliderCount
		var reviewSlider = new Splide( '.brator-client-review', {
			type       : 'fade',
			cover      : true,
			rewind     : true,
			pagination : false
		} );
		
		var reviewSliderAuthor = new Splide( '.brator-client-review-author', {
			// rewind     : true,
			focus : 1,
			pagination : false,
			arrows : false,
			perPage : 3,
			perMove : 1,
			breakpoints : {
				1026: {
					perPage: 2
				},
				767: {
					perPage: 1
				}
			}
			} );
		reviewSlider.sync(reviewSliderAuthor);
		reviewSlider.mount();
		reviewSliderAuthor.mount();
	}
	document.addEventListener("shopify:section:load", e => {
		let reviewSyncAuthore = document.getElementsByClassName( 'brator-client-review-author' );
		let reviewSyncReview = document.getElementsByClassName( 'brator-client-review' );

		if(reviewSyncAuthore.length > 0 ){
			// reviewSliderCount
			var reviewSlider = new Splide( '.brator-client-review', {
				type       : 'fade',
				cover      : true,
				rewind     : true,
				pagination : false
			} );
			
			var reviewSliderAuthor = new Splide( '.brator-client-review-author', {
				// rewind     : true,
				focus : 1,
				pagination : false,
				arrows : false,
				perPage : 3,
				perMove : 1,
				breakpoints : {
					1026: {
						perPage: 2
					},
					767: {
						perPage: 1
					}
				}
			  } );
			reviewSlider.sync(reviewSliderAuthor);
			reviewSlider.mount();
			reviewSliderAuthor.mount();
		}
	});
		/*
			splide end
		*/

		/*
			tab start
		*/
		document.body.classList.add("pp-type-grid")
		let gridList = document.querySelectorAll( '.brator-filter-view-type-link' );
		if(gridList.length > 0 ){
			gridList.forEach(
				(item, index) => {
					item.addEventListener('click', ()=>{
						gridList.forEach(
							(item, index) => {
								if(item.classList.contains("current")) item.classList.remove("current")
							}
						)
						item.classList.add("current")
						if(item.classList.contains("pp-type-grid")){
							document.getElementById('ProductGridContainer').classList.remove("type-list")
						}else{
							document.getElementById('ProductGridContainer').classList.add("type-list")
						}
					})
				}
			)
		}

		let productInfoImg = document.getElementsByClassName( 'brator-product-img-tab-list' );
		if(productInfoImg.length > 0 ){
			var tabProductImgItem = new Tabs({
				elem: "tabs-product-img",
				open: 0
			});	
			tabProductImgItem.open(0);
		}


		let productInfoTab = document.getElementsByClassName( 'brator-product-img-tab-list' );

		if(productInfoTab.length > 0 ){
			var tabProductItem = new Tabs({
				elem: "tabs-product-content",
				open: 0
			});
			tabProductItem.open(0);
		}


		if($('.brator-slide-menu-area .mega-menu-li').length){
			$('.brator-slide-menu-area .mega-menu-li > a').append('<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/> </svg>')
		}

		if($('.brator-slide-menu-area .mega-menu-li').length){
			$('.brator-slide-menu-area .mega-menu-li a svg').on('click', function(e) {

				$(this).toggleClass('open');

				$(this).closest('.mega-menu-li').children('.mega-menu-area').slideToggle(500);

			})
		}


		if($('.brator-slide-menu-area .down-menu').length){
			$('.brator-slide-menu-area .down-menu-child > a').append('<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/> </svg>')
		}

		if($('.brator-slide-menu-area .down-menu').length){
			$('.brator-slide-menu-area .down-menu a svg:not(.down-menu-child a svg)').on('click', function(e) {
				e.preventDefault()
				$(this).toggleClass('open');
				$(this).closest('.down-menu').children('ul').slideToggle(500);
			})
		}

		if($('.brator-slide-menu-area .down-menu .down-menu-child').length){
			$('.brator-slide-menu-area .down-menu:not(.down-menu a svg) .down-menu-child a svg').on('click', function(e) {
                e.preventDefault()
				$(this).toggleClass('open');
				$(this).closest('.n-menu-child').children('ul').slideToggle(500);
			})
		}
		
		/*
			tab end
		*/

	} );

	/*
		loading start
	*/

	function handlePreloader() {
        if ($('.loader-wrap').length) {
            $('.loader-wrap').hide()
        }
    }
 
	/*
		loading end
	*/

	/*
		cart start
	*/
	if($('.brator-cart-link').length){
		$('.brator-cart-link #cart-icon-bubble, .brator-cart-link #cart-icon-bubble-mobile').on('click', function(e) {
			let spineLo = document.querySelector('.brator-cart-item-list-overlay')
			spineLo.classList.add('open')

			let monYfun = (currency, price) => {
				return (
					new Intl.NumberFormat('en-IN', { style: 'currency', currency: currency }).format(price/100)
				)
			}
			axios({
				method: "get",
				url: `/cart.js`
			})
			.then(
				response => {

					let { items, item_count, original_total_price, total_price, total_discount, currency  } = response.data
					let cartCount = document.querySelector('.min-cart-br-count')
					cartCount.innerHTML = `(${item_count} items)`

					let renderItemsTarget = document.querySelector('.brator-cart-item-list-item-area-me')
					renderItemsTarget.innerHTML = ''

					items.forEach(
						( { id, quantity, title, price, url, image, handle, product_title, final_price, product_type, discounted_price, final_line_price } ) => {

							let disC = `<span></span>`
							
							let renderItems = `<div class="brator-cart-item-list-item"> <div class="brator-cart-item-list-item-img"><a href="${url}"><img src="${image}" alt="${handle}"/></a></div> <div class="brator-cart-item-list-item-title"> <div class="brator-cart-item-list-item-title-one"><a href="${url}"> <h2>${product_title}</h2></a> <div class="price-pdo"> <h4>${quantity}</h4> <h5>x</h5> <h6><span>${monYfun(currency, final_price)}</span>${disC}</h6> </div> </div> <div class="brator-cart-item-list-item-title-accetion"> <p>${product_type}</p> <div class="brator-cart-item-list-item-title-accetion-part"><a href="${url}"> <svg class="bi bi-pencil-square" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"> <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"></path> <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"></path> </svg></a> </div> </div> </div> </div>`
							renderItemsTarget.innerHTML += renderItems
						}
					)
					let totalPrice = document.querySelector('.brator-cart-total-header-count')
					totalPrice.innerHTML = monYfun(currency, total_price)
				}
			)
			.catch(function (error) {
				console.log(error)
			})
			.finally(() => {
				// you finaly code here
				let spineLo = document.querySelector('.brator-cart-item-list-overlay')
				spineLo.classList.remove('open')
			})


			$('.brator-cart-item-list').toggleClass('mini-cart-open');

		});
	}

	$('.brator-cart-close').on('click', function(e) {
		$('.brator-cart-item-list').removeClass('mini-cart-open');
	});

	/*
		wl start
	*/
	
	if($('.wish-list-slide').length){
		$('.wish-list-slide').on('click', function(e) {
			$('body').toggleClass('mini-wish-open')
		})
	}

	if($('.wpl-dwar-close').length){
		$('.wpl-dwar-close').on('click', function(e) {
			$('body').toggleClass('mini-wish-open')
		})
	}

	/*
		wl end
	*/

	/*
		cmPa start
	*/
	
	if($('.compa-list-slide').length){
		$('.compa-list-slide').on('click', function(e) {
			$('body').toggleClass('mini-compa-open')
		})
	}

	if($('.compa-dwar-close-area').length){
		$('.compa-dwar-close-area').on('click', function(e) {
			$('body').toggleClass('mini-compa-open')
		})
	}

	
	// cookies start
		const handleDeclineSelector = document.getElementById('decline-btn-cok')
		const handleAcceptSelector = document.getElementById('accept-btn-cok')

		function getBannerEl() {
			return document.getElementById('cookies-banner');
		}

		function hideBanner(res) {
			getBannerEl().style.display = 'none';
		}

		function showBanner() {
		getBannerEl().style.display = 'block';
		}

		handleAcceptSelector.addEventListener('click', handleAccept)
		function handleAccept(e) {

			localStorage.setItem('kuki', 'kuki-acc')  
			window.Shopify.customerPrivacy.setTrackingConsent(true, hideBanner);

			document.addEventListener('trackingConsentAccepted',function() {
			console.log('trackingConsentAccepted event fired');
			});
		}

		handleDeclineSelector.addEventListener('click', handleDecline)
		function handleDecline() {
			window.Shopify.customerPrivacy.setTrackingConsent(false,hideBanner);
		}

		function initCookieBanner() {
			const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
			const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

			if(!userCanBeTracked && userTrackingConsent === 'no_interaction') {
			showBanner();
			}
		}

		window.Shopify.loadFeatures([
			{
			name: 'consent-tracking-api',
			version: '0.1',
			}
		],
		function(error) {
			if (error) {
			throw error;
			}

			initCookieBanner();
		});

		// cookies end

	
	var getLogo = $('.brator-header-area .brator-logo').html();
	var getMenu = $('.brator-header-menu-area .brator-header-menu').html();
	
	if($('.brator-logo button').length){
		$('.brator-logo button').on('click', function() {
			$('body').addClass('mobile-menu-open');
		});

		$('.brator-slide-menu-bg').on('click', function() {
			$('body').removeClass('mobile-menu-open');
		});
		$('.brator-slide-menu-close').on('click', function() {
			$('body').removeClass('mobile-menu-open');
		});

		if($('.brator-slide-logo-items').length){
			$('.brator-slide-logo-items').append(getLogo);
		}
		if($('.brator-slide-menu-items').length){
			$('.brator-slide-menu-items').append(getMenu);
		}

	}

	/*
		menu end
	*/

	/*
		filtter start
	*/

	if($('.filter-enable').length){
		$('.filter-enable').on('click', function() {
			$('body').addClass('shop-filter-open');
		});
	}

	if($('.brator-sidebar-area.design-one .close-fillter').length){
		$('.brator-sidebar-area.design-one .close-fillter').on('click', function() {
			$('body').removeClass('shop-filter-open');
		});
	}


	/*
		filtter end
	*/

	/*
		mega menu  start
	*/


	$(".brator-header-menu li.mega-menu-li").click(function(){
		$(".brator-header-menu li").removeClass('active');
		$(this).addClass('active');
		$('body').addClass('brator-header-menu-bg');
		let docHeight = $(document).height() + 'px'
		$('.close-menu-bg').css("height", docHeight);
		
	});

	$(".close-menu-bg" ).click(function(){
		$(".brator-header-menu li").removeClass('active');
		$('body').removeClass('brator-header-menu-bg');
		let docHeight = 'auto'
		$('.close-menu-bg').css("height", docHeight);
	});

	$(".brator-mega-menu-close").click(function(){
		$(".brator-header-menu li").removeClass('active');
		$('body').removeClass('brator-header-menu-bg');
		let docHeight = 'auto'
		$('.close-menu-bg').css("height", docHeight);
	});

	/*
		mega menu end
	*/

	/*
		filter  start
	*/

	if($('.brator-filter-item-area').length){
		$('.brator-filter-item-title').on("click", function(){
			if($(this).hasClass('current')){
				$(this).removeClass('current');
				let elHeight = $(this)[0].nextElementSibling.scrollHeight
				$(this).next().css("maxHeight", `${0}px`)
				$(this).next().css("height", `${0}px`)
			}else{
				$(this).addClass('current');
				let elHeight = $(this)[0].nextElementSibling.scrollHeight
				$(this).next().css("maxHeight", `${elHeight}px`)
				$(this).next().css("height", `${elHeight}px`)
			}
		});
	}
	
	if($('.rest-all-checkbox').length){
		$('.rest-all-checkbox').on("click", function(){
			$('.shop-sidebar-content input:checkbox').removeAttr('checked');
		});
	}

	if($('.sub-cat').length){
		$('.sub-cat').on("click", function(){
			
			if($(this).hasClass('current')){
				$(this).removeClass('current');
			}else{
				$(this).addClass('current');
			}
		});
	}


	/*
		filter end
	*/

	/*
		view more text  start
	*/

	if($('.brator-makes-list-view-more button').length){
		$('.brator-makes-list-view-more button').on("click", function(){
			if($('.brator-makes-list-single.disable').hasClass('current')){
				$('.brator-makes-list-single.disable').removeClass('current');
				$('.brator-makes-list-view-more button span b ').text('view more');
				$('.brator-makes-list-view-more button').removeClass('current');
			}else{
				$('.brator-makes-list-single.disable').addClass('current');
				$('.brator-makes-list-view-more button span b ').text('view less');
				$('.brator-makes-list-view-more button').addClass('current');
			}
		});
	}

	if($('.brator-more-text-view-more').length){
		$('.brator-more-text-view-more').on("click", function(){
			if($('.brator-more-text-view-more').hasClass('current')){
				$('.brator-more-text-view-more').removeClass('current');
				$('.brator-more-text-content .disable').removeClass('current');
				$('.brator-more-text-view-more button span').text('view more');
			}else{
				$('.brator-more-text-content .disable').addClass('current');
				$('.brator-more-text-view-more').addClass('current');
				$('.brator-more-text-view-more button span').text('view less');
			}
		});
	}


	/*
		view more text end
	*/

	/*
		input start
	*/


		
	let priceMin = $(".brator-rang-item-input-single input[name='filter.v.price.gte']").attr('value');
	if(priceMin != ''){
		$(".brator-rang-item-input-single input[name='filter.v.price.gte']").addClass('current')
	}
		
	let priceMax = $(".brator-rang-item-input-single input[name='filter.v.price.lte']").attr('value');
	if(priceMax != ''){
		$(".brator-rang-item-input-single input[name='filter.v.price.lte']").addClass('current')
	}

	$(".brator-rang-item-input-single input[name='filter.v.price.gte']").change( e => {
		let priceMinUpdate = e.target.value;
		if(priceMinUpdate != ''){
			$(".brator-rang-item-input-single input[name='filter.v.price.gte']").addClass('current-yaps')
		}else{
			$(".brator-rang-item-input-single input[name='filter.v.price.gte']").removeClass('current-yaps')
		}
	})

	$(".brator-rang-item-input-single input[name='filter.v.price.lte']").change( e => {
		let priceMaxUpdate = e.target.value;
		if(priceMaxUpdate != ''){
			$(".brator-rang-item-input-single input[name='filter.v.price.lte']").addClass('current-yaps')
		}else{
			$(".brator-rang-item-input-single input[name='filter.v.price.lte']").removeClass('current-yaps')
		}
	})

	/*
		input end
	*/

	/*
		coming soon start
	*/

	if($('.brator-coming-soon-counter').length){
		let dataTimer = $('.brator-coming-soon-counter').attr("data-options") 


		let {timer_year, timer_month, timer_day} = JSON.parse(dataTimer)
		

		// Set the date we're counting down to
		var countDownDate = new Date(`${timer_month} ${timer_day}, ${timer_year} 12:00:00`).getTime();
	
		// Update the count down every 1 second
		var x = setInterval(function() {
	
		// Get todays date and time
		var now = new Date().getTime();
	
		// Find the distance between now an the count down date
		var distance = countDownDate - now;
	
		// Time calculations for days, hours, minutes and seconds
		var days = Math.floor(distance / (1000 * 60 * 60 * 24));
		var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		var seconds = Math.floor((distance % (1000 * 60)) / 1000);
	
		// Display the result in the element with id="demo"
	
		document.getElementById("days").innerText = days
		document.getElementById("hours").innerText = hours
		document.getElementById("minutes").innerText = minutes
		document.getElementById("seconds").innerText = seconds
	
	
	
		// If the count down is finished, write some text 
			if (distance < 0) {
				clearInterval(x);
				document.getElementById("demo").innerHTML = "EXPIRED";
			}
		}, 1000);
	}







	let airStore = (JSON.parse(localStorage.getItem('compa'))) ? (JSON.parse(localStorage.getItem('compa'))) : []

	if(airStore.length == 0 ){
		document.body.classList.add('no-compare-product-link')
	}
	if(airStore.length > 0 ){  
		document.body.classList.remove('no-compare-product-link')
	}


	var compaDwar = document.querySelector('.compa-dwar ')
	compaDwar.innerHTML = ""
	airStore.forEach(
		(product, index) => {
			compaDwar.innerHTML += `<div class="brator-product-single-item-area splide__slide design-two"> <div class="brator-compare-product-content"> <div class="brator-product-single-item-info info-content-flex"> <div class="brator-product-single-item-info-right"><compa-list class="compa-incdec-area" data-api="${product.handle}"> <button id="btn-${product.handle}" class="compa-incdec active"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"></path> <path fill-rule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"></path> </svg></button> </compa-list></div> <div class="brator-product-single-item-info-left"> <div class="off-batch">20% OFF</div> </div> </div> <div class="brator-product-single-item-img"><a href="${product.url}"><img src="${product.featured_image}" alt="${product.title}"/></a></div> <div class="brator-product-single-item-mini"> <div class="brator-product-single-item-cat"><a href="product-layout-01.html">Brakepro</a></div> <div class="brator-product-single-item-title"> <h5><a href="${product.url}">${product.title}</a></h5> </div> <div class="brator-product-single-item-price"> <p><sub>$172.96</sub><b class="pub">$100</b></p> </div> </div> </div> <div class="brator-compare-product-info"> <div class="brator-compare-info-list"> <p>Short unique description</p> </div> <div class="brator-compare-info-list"> <p>Guess</p> </div> <div class="brator-compare-info-list"> <p>White</p> </div> <div class="brator-compare-info-list"> <p>Included Tax</p> </div> <div class="brator-compare-info-list"> <p>-</p> </div> </div> </div>`
		}
	)
	
	if($('.compa-dwar-action').length){
		$('.compa-dwar-action .product-compa-removed').click(function(){
			localStorage.removeItem('compa')
			document.querySelector('.compa-list-count').textContent = 0
			document.querySelector('.compa-dwar').innerHTML = ''
			document.body.classList.add('no-compare-product-link')
			document.querySelectorAll('.compa-incdec').forEach(
				(product, index) => {
					product.classList.remove('active')
				}
			)
		})
	}	



	let airStoreWi = (JSON.parse(localStorage.getItem('wPl'))) ? (JSON.parse(localStorage.getItem('wPl'))) : []
	if(airStoreWi.length == 0 ){
		document.body.classList.add('no-wish-product-link')
	}
	if(airStoreWi.length > 0 ){  
		document.body.classList.remove('no-wish-product-link')
	}

	var wplDwar = document.querySelector('.wpl-dwar')
	wplDwar.innerHTML = ""
	airStoreWi.forEach(
        (product, index) => {
          wplDwar.innerHTML += `<div class="brator-product-wpl-area"><div class="brator-product-single-item-img"> <a href="${product.url}"> <img src="${product.featured_image}" alt="${product.title}" loading="lazy" class="motion-reduce" width="925" height="617"> </a> </div> <div class="brator-product-single-item-mini"> <div class="brator-product-single-item-title"> <h5><a href="${product.url}"> ${product.title}</a></h5><wish-list class="wish-list" data-api="${product.handle}"> <button id="wish-${product.handle}" class="brator-wish-list-custom"> Remove </button> </wish-list></div> </div> </div>`
        }
	)

	if($('.wpl-dwar-action').length){
		$('.wpl-dwar-action .product-wish-removed-all').click(function(){
			localStorage.removeItem('wPl')
			document.querySelector('.wish-list-count').textContent = 0
			document.querySelector('.wpl-dwar').innerHTML = ''
			document.body.classList.add('no-wish-product-link')

			document.querySelectorAll('.brator-wish-list-custom').forEach(
				(product, index) => {
					product.classList.remove('active')
				}
			)

		})
	}
	
	/*
		coming soon end
	*/


})(window.jQuery);	